import api from "./core";

const basePath = "api/{{serverSegment}}/DoseSpot";

export default {
  query(patientId, extraHeaders = {}) {
    return api.get(`${basePath}/ActiveMedications/${patientId}`, extraHeaders);
  },
};
